module.exports = __webpack_public_path__ + "static/media/three.14c0ec32.png";